import { createTypes, createAsyncTypes } from '../../utils';

const prefix = 'preliminarySession';

const types = createTypes(prefix, [
    'SET_PRELIMINARY_SESSION'
]);

const asyncTypes = createAsyncTypes(prefix, [
    'CANCEL_PRELIMINARY_SESSION'
]);

export default {
    ...types,
    ...asyncTypes
};
